import { AppStateType } from "../rootReducer";
export const isQuestionLoading = (state: AppStateType) => state.question.loading;
export const getIntent = (state: AppStateType) => state.question.intent;
export const getButtonOptions = (state: AppStateType) => state.question.buttonOptions;
export const AllUserGroups = (state: AppStateType) => state.question.groups;
export const getAllIntents = (state: AppStateType) => state.question.intents;